import React from 'react'
import ReactDatePicker from 'react-datepicker'
import './DatePicker.scss'

let DatePicker = ({
  date = Date.now(),
  onChange,
  style = {},
  className = '',
}) => {
  let divProps = {
    ...(style && { style }),
    ...(className && { className }),
  }
  return (
    <div {...divProps}>
      <ReactDatePicker
        className="form-control"
        popperPlacement="auto"
        selected={new Date(date)}
        onChange={onChange}
      />
    </div>
  )
}

export default DatePicker
